// extracted by mini-css-extract-plugin
export var content = "CreateAccount-module__content___t0aaX";
export var header = "CreateAccount-module__header___vQHxM";
export var logo = "CreateAccount-module__logo___ZfhNJ";